<xi-horizontal-tab-bar
  [stretch]="true"
  [hasTransparentBackground]="true"
  [data]="tabs"
  [(activeTabId)]="activeTab"
>
</xi-horizontal-tab-bar>

<ng-container *transloco="let t; read: 'widgets.ai-insights'">
  @if (showGenerateTab() && activeTab() === 'generate') {
    <div
      class="ai-insights__generate-container"
      [class.ai-insights__generate-container--point-selection]="isPointSelectionFlow()"
    >
      <div class="ai-insights__generate-container-header">{{ t('select-question') }}</div>

      <xi-list select="single" size="normal" [value]="selectedScene">
        <div slot="children">
          @for (scene of availableScenes; track $index) {
            <div>
              <xi-list-item
                [checked]="selectedScene === scene"
                [value]="scene"
                [disabled]="scene.disabled || isPointSelectionFlow()"
                [tooltip]="{ text: scene.tooltip }"
                (onItemClick)="onSceneSelected($event)"
              >
                <div slot="children">
                  @if (scene.nickname) {
                    <div class="ai-insights__scene-header">{{ scene.nickname }}</div>
                  }

                  {{ scene.shortPurpose }}
                </div>
              </xi-list-item>
            </div>
          }
        </div>
      </xi-list>

      @if (isPointSelectionFlow()) {
        @if (remainingPointsMin > 0) {
          <div>{{ t('remaining-points-minimum', { count: remainingPointsMin }) }}</div>
        } @else {
          <div>{{ t('remaining-points-maximum', { count: remainingPointsMax }) }}</div>
        }
      }

      <div
        class="ai-insights__generate-actions"
        [class.ai-insights__generate-actions--single-action]="isZeroPointSelection()"
      >
        @if (selectedScene && !isPointSelectionFlow() && !isZeroPointSelection()) {
          <xi-default-button
            color="CX"
            [text]="t('choose-points')"
            (onClick)="onChoosePoints()"
            class="ai-insights__choose-points-button"
          ></xi-default-button>
        }
        @if (isPointSelectionFlow() || isZeroPointSelection()) {
          @if (!isZeroPointSelection()) {
            <xi-default-button
              fill="outline"
              [text]="t('cancel')"
              (onClick)="onCancel()"
            ></xi-default-button>
          }

          <xi-default-button
            color="CX"
            [text]="t('generate')"
            [disabled]="!isSelectionValid()"
            (onClick)="onGenerateInsight()"
          ></xi-default-button>
        }
      </div>
    </div>
  }
  @if (activeTab() === 'list') {
    <div class="ai-insights__list-container">
      @if (isInsightsLoading()) {
        <div class="xi-loader-container__inline-overlay xi-loader-container__inline-overlay--blur">
          <xi-animation
            [height]="75"
            [width]="75"
            [loop]="true"
            animation="cx_loader"
          ></xi-animation>
        </div>
      }
      @for (insight of widgetAiInsightsService.aiInsights$ | async; track $index) {
        <app-insight-card
          [insight]="insight"
          [options]="options()"
          (insightDeleted)="onInsightDeleted(insight)"
          (regenerateInsight)="onRegenerateInsight(insight)"
          (publishInsight)="onPublishInsight($event)"
        ></app-insight-card>
      } @empty {
        <div class="ai-insights__empty">{{ t('no-insights') }}</div>
      }
    </div>
  }
</ng-container>
